import { Accessibility } from "./accessibility";
import { Laverie } from "./laverie";
import { User } from "./user";
import { Account } from "./account";

export enum LivrerPar {
    TECHNIQUE = "TECHNIQUE",
    TRANSPORTS = "TRANSPORTS",
    AUTRE = "AUTRE"
}

export enum SignalementType {
    Visite_Pre_Installation = "Visite_Pre_Installation",
    Signalement_Technicien = "Signalement_Technicien"
}

// Visite preinstallation
export interface FicheSignalement {
    type: SignalementType
    account: Account
    laverie: Laverie
    visitDate: Date
    visitedBy: User
    motifSignalement: string
    accessibility: Accessibility
    techUser: User
    manager: User
}

export class FicheSignalementGen {
    // type.Visite_Pre_Installation
    tv: string
    htv: boolean

    // type.Signalement_Technicien
    ts: string
    hts: boolean

    // account.name
    an: string

    // laverie.numeroDeContrat
    lnc: string

    // laverie.name
    ln: string

    // laverie.address.ville
    lav: string

    // laverie.address.numero
    lan: string

    // laverie.address.rue
    lar: string

    // laverie.address.codepostale
    lacp: string

    // visitDate
    vd: string
    hvd: boolean

    // visitedBy
    vb: string
    hvb: boolean

    // motifSignalement
    ms: string
    hms: boolean

    // Lave-linge model
    llm: string
    hllm: boolean

    // Lave-linge contrat
    llc: string
    hllc: boolean

    // Lave-linge numero
    lln: string
    hlln: boolean

    // Lave-linge prise
    llp: string
    hllp: boolean

    // Lave-linge Nbre
    llnb: string
    hllnb: boolean

    // Lave-linge Neuf
    llne: string
    hllne: boolean

    // Lave-linge Occasion
    llo: string
    hllo: boolean

    // Lave-linge Evacuation
    lle: string
    hlle: boolean

    // Lave-linge Prix lavage
    llpl: string
    hllpl: boolean

    // Lave-linge Mode de paiement
    llmp: string
    hllmp: boolean

    // Lave-linge Matériel de paiement
    llmpa: string
    hllmpa: boolean

    // Lave-linge Autre
    lla: string
    hlla: boolean

    // Sèche-linge model
    slm: string
    hslm: boolean

    // Sèche-linge contrat
    slc: string
    hslc: boolean

    // Sèche-linge numero
    sln: string
    hsln: boolean

    // Sèche-linge prise
    slp: string
    hslp: boolean

    // Sèche-linge nbre
    slnb: string
    hslnb: boolean

    // Sèche-linge neuf
    slne: string
    hslne: boolean

    // Sèche-linge occasion
    slo: string
    hslo: boolean

    // Sèche-linge evacuation
    sle: string
    hsle: boolean

    // Sèche-linge prix séchage
    slps: string
    hslps: boolean

    // Sèche-linge mode de paiement
    slmp: string
    hslmp: boolean

    // Sèche-linge matériel de paiement
    slmpa: string
    hslmpa: boolean

    // Sèche-linge temps séchage
    slts: string
    hslts: boolean

    // Stacked model
    sm: string
    hsm: boolean

    // Stacked contrat
    sc: string
    hsc: boolean

    // Stacked numero
    sn: string
    hsn: boolean

    // Stacked prise
    sp: string
    hsp: boolean

    // Stacked Nbre
    snb: string
    hsnb: boolean

    // Stacked Neuf
    sne: string
    hsne: boolean

    // Stacked Occasion
    so: string
    hso: boolean

    // Stacked Matériel paiement
    smp: string
    hsmp: boolean

    // Stacked prix lavage
    spl: string
    hspl: boolean

    // Stacked prix séchage
    sps: string
    hsps: boolean

    // Stacked temps séchage
    sts: string
    hsts: boolean

    // Stacked mode de paiement
    smpa: string
    hsmpa: boolean

    // Options chauffe eau
    oce: string
    hoce: boolean

    // Options condensateur
    oc: string
    hoc: boolean

    // Options sous comptage
    osc: string
    hosc: boolean

    // Options clé caisse
    occ: string
    hocc: boolean

    // Options clé trappe
    oct: string
    hoct: boolean

    // Options Lint trapp
    olt: string
    holt: boolean

    // Options Jetons LL 11MS/10MS
    oj11: string
    hoj11: boolean

    // Options Jetons SL 55MS/35MS
    oj55: string
    hoj55: boolean

    // Options Pompe à lessive
    opl: string
    hopl: boolean

    // Accessibility Etage
    aet: string
    haet: boolean

    // Accessibility Ascenseur
    aa: string
    haa: boolean

    // Accessibility Escalier
    ae: string
    hae: boolean

    // Accessibility Code porte
    acp: string
    hacp: boolean

    // Accessibility Parking privé
    ap: string
    hap: boolean

    // Accessibility BIP
    ab: string
    hab: boolean

    // Accessibility Clé
    ac: string
    hac: boolean

    // Accessibility Autre
    aau: string
    haau: boolean

    // Contact technique nom
    ctn: string
    hctn: boolean

    // Contact technique mail
    ctm: string
    hctm: boolean

    // Contact technique tel
    ctt: string
    hctt: boolean

    // Contact technique mobile
    ctmo: string
    hctmo: boolean

    // Responsable site nom
    rsn: string
    hrsn: boolean

    // Responsable site mail
    rsm: string
    hrsm: boolean

    // Responsable site tel
    rst: string
    hrst: boolean

    // Responsable site mobile
    rsmo: string
    hrsmo: boolean

    // Code tournée (laverie.codeTournee)
    ct: string
    hct: boolean

    // Périodicité (laverie.periodicity)
    p: string
    hp: boolean
}

export function flattenFicheSignalement(input: FicheSignalement): FicheSignalementGen {
    const b = new FicheSignalementGen();

    if (input.type == SignalementType.Visite_Pre_Installation) {
        b.tv = "X"
        b.htv = true
    } else {
        b.htv = false
    }

    if (input.type == SignalementType.Signalement_Technicien) {
        b.ts = "X"
        b.hts = true
    } else {
        b.hts = false
    }

    if (input.account) {
        b.an = input.account.name
    }

    if (input.laverie) {
        b.ln = input.laverie.name
        b.lnc = input.laverie.numeroDeContrat.toString()
        b.lan = input.laverie.address.numero
        b.lar = input.laverie.address.rue
        b.lav = input.laverie.address.ville
        b.lacp = input.laverie.address.codepostale
        if (input.laverie.codeTournee) {
            b.ct = input.laverie.codeTournee
            b.hct = true
        } else {
            b.hct = false
        }
        if (input.laverie.periodicity) {
            b.p = input.laverie.periodicity
            b.hp = true
        } else {
            b.hp = false
        }
    }

    if (input.visitDate) {
        b.vd = input.visitDate.toString()
        b.hvd = true
    } else {
        b.hvd = false
    }

    if (input.visitedBy) {
        b.vb = input.visitedBy.lastname.concat(" ").concat(input.visitedBy.name)
        b.hvb = true
    } else {
        b.hvb = false
    }

    if (input.motifSignalement) {
        b.ms = input.motifSignalement
        b.hms = true
    } else {
        b.hms = false
    }

    if (input.accessibility) {
        if (input.accessibility.etage) {
            b.aet = input.accessibility.etage
            b.haet = true
        } else {
            b.haet = false
        }
        if (input.accessibility.codePorte) {
            b.acp = input.accessibility.codePorte
            b.hacp = true
        } else {
            b.hacp = false
        }
        if (input.accessibility.key) {
            b.ac = input.accessibility.key
            b.hac = true
        } else {
            b.hac = false
        }
        if (input.accessibility.bip) {
            b.ab = input.accessibility.bip
            b.hab = true
        } else {
            b.hab = false
        }
        if (input.accessibility.ascenseur) {
            b.aa = input.accessibility.ascenseur
            b.haa = true
        } else {
            b.haa = false
        }
        if (input.accessibility.escalier) {
            b.ae = input.accessibility.escalier
            b.hae = true
        } else {
            b.hae = false
        }
        if (input.accessibility.parking) {
            b.ap = input.accessibility.parking
            b.hap = true
        } else {
            b.hap = false
        }
    }
    if (input.techUser) {
        if (input.techUser.lastname) {
            b.ctn = input.techUser.lastname
            b.hctn = true
        }
        if (input.techUser.firstname) {
            if (b.ctn) {
                b.ctn = b.ctn.concat(" ").concat(input.techUser.firstname)
            } else {
                b.ctn = input.techUser.firstname
            }
        }

        b.hctn = !!b.ctn

        if (input.techUser.email) {
            b.ctm = input.techUser.email
            b.hctm = true
        } else {
            b.hctm = false
        }
        if (input.techUser.telephone) {
            b.ctt = input.techUser.telephone
            b.hctt = true
        } else {
            b.hctt = false
        } if (input.techUser.mobile) {
            b.ctmo = input.techUser.mobile
            b.hctmo = true
        } else {
            b.hctmo = false
        }
    }
    if (input.manager) {
        if (input.manager.lastname) {
            b.rsn = input.manager.lastname
            b.hrsn = true
        }
        if (input.manager.name) {
            if (b.rsn) {
                b.rsn = b.rsn.concat(" ").concat(input.manager.name)
            } else {
                b.rsn = input.manager.name
            }
        }

        b.hrsn = !!b.rsn

        if (input.manager.email) {
            b.rsm = input.manager.email
            b.hrsm = true
        } else {
            b.hrsm = false
        }
        if (input.manager.telephone) {
            b.rst = input.manager.telephone
            b.hrst = true
        } else {
            b.hrst = false
        }
        if (input.manager.mobile) {
            b.rsmo = input.manager.mobile
            b.hrsmo = true
        } else {
            b.hrsmo = false
        }
    }
    return b
}